import { logger } from "../../utils/logger";

/**
 * Gets the user's timezone from localStorage or browser
 * @returns The user's timezone string
 */
export const getUserTimezone = (): string => {
  try {
    // First try to get from localStorage
    if (typeof window !== "undefined" && window.localStorage) {
      const storedTimezone = localStorage.getItem("userTimezone");
      if (storedTimezone) {
        return storedTimezone;
      }
    }

    // Fallback to browser's detected timezone
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    logger.error("Error getting user timezone:", error);
    // Final fallback
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
};
